import { parseCurrencyType, type CurrencyType } from '@/lib/currency'

/**
 * Betfair line session NE display — Lab dashboard `currencyConvertor` parity.
 *
 * - POINTS: API INR majors → Pts (`inrMajorToDisplay` / ÷100)
 * - POINT@1: no convert (Sportsbook already uses point fields)
 * - INR: unchanged
 *
 * Match Odds / custom Fancy must not call this.
 */
export function lineSessionMoneyOpts(rawCurrency: string | undefined | null): {
  currency: CurrencyType
  alreadyDisplay: boolean
} {
  const raw = String(rawCurrency ?? 'INR')
    .trim()
    .toUpperCase()
  if (raw === 'POINT@1' || raw === 'POINT1' || raw === 'POINT_AT_1') {
    return { currency: 'INR', alreadyDisplay: true }
  }
  return { currency: parseCurrencyType(raw), alreadyDisplay: false }
}
